import { Children } from 'react'
import PageColumn from './PageColumnTemplate'
import { isArray } from 'lodash'
import { styled } from '@mui/material'
import { COLUMN_SEPARATOR_WIDTH } from '../PageTemplate/constants'
import { contentSpacing } from 'ComponentLibrary/src/styles/moduleSpacings'

type PageRowProps = {
    children: [React.ReactNode, React.ReactNode] | React.ReactNode
    style?: React.CSSProperties
    withoutMaxWidth?: boolean
}

export default function PageRow({ children, style, withoutMaxWidth = false }: PageRowProps) {
    if (Children.count(children) > 2) {
        throw new Error('PageRow can only have 2 children max')
    }

    return (
        <RowContainer className="pageRow" style={style}>
            {isArray(children) ? (
                <>
                    <PageColumn withoutMaxWidth={withoutMaxWidth}>{children[0]}</PageColumn>
                    <PageColumn withoutMaxWidth={withoutMaxWidth}>{children[1]}</PageColumn>
                </>
            ) : (
                <>
                    <PageColumn withoutMaxWidth={withoutMaxWidth}>{children}</PageColumn>
                </>
            )}
        </RowContainer>
    )
}

const RowContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: `${COLUMN_SEPARATOR_WIDTH}px`,
    [theme.breakpoints.down('singleColumn')]: {
        '& > *:last-child > *:not(.headline):first-child': {
            marginTop: `${contentSpacing}px`,
        },
    },
}))
